export default "__VITE_ASSET__c1786a6a__"